<template>
  <button
    :class="[$style.button, { [$style['button--disabled']]: disabled }]"
    :disabled="disabled"
  >
    <slot name="icon" />
  </button>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ disabled?: boolean }>(), { disabled: false })
</script>

<style lang="scss" module>
.button {
  line-height: 0;
  color: $color-text-and-object-high-emphasis;

  &--disabled {
    color: $color-text-and-object-disable;
  }
}
</style>
